import { allModelsSelector, singleModelSelector } from 'common-src/utils/selectorUtils';

import DashboardV2Task from './DashboardV2Task';

export const getDashboardV2Tasks = (state) =>
  allModelsSelector(state, DashboardV2Task.modelName).sort(
    (a, b) => new Date(a?.due || 0) - new Date(b?.due || 0),
  );

export const getDashboardV2Task = (state, id) =>
  singleModelSelector(state, DashboardV2Task.modelName, id);
